import React, { useState, useContext, useEffect } from 'react';
import { Box, Grid, Paper, Typography, TextField, MenuItem, Checkbox, FormControl, ListItemText, Select, FormGroup, FormControlLabel, Radio } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import ApiService from "../../functions/apiService";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Multiselect from 'multiselect-react-dropdown';

const AdjustHours = () => {
    const [selectedList, setSelectedList] = useState('');
    const [selectedReason, setSelectedReason] = useState('');
    const [hours, setHours] = useState('');
    const [reasonDescription, setReasonDescription] = useState('');
    const [selectedType, setSelectedType] = useState('adjust');
    const [dateValue, setDateValue] = useState(dayjs().format('YYYY-MM-DD'));
    const [searchTerm, setSearchTerm] = useState('');
    const [employeesList, setEmployeesList] = useState([]);
    const [list, setList] = useState([]);
    const [reasonList, setReasonList] = useState([]);
    const [selectedEmp, setSelectedEmp] = useState([])

    useEffect(() => {
        ApiService.get('/getEmployeeDDL', {}, 'getEmployeeDDL')
            .then(({ data }) => {
                var tempArr = []
                data.map((emp) => {
                    var obj = emp
                    obj.label = `${emp.EA_Rank || ''} ${emp.fullName}`
                    tempArr.push(obj)
                })
                setEmployeesList(tempArr)
            }).catch((error) => {
                toast.error(error)
            })

        ApiService.get('/getAdjustHoursOvertimeList')
            .then(({ data }) => {
                const formattedData = Object.entries(data.data).map(([key, value]) => ({
                    value: key,
                    label: value
                }))
                setList(formattedData)
                setSelectedList(formattedData[formattedData.length - 1].value)
            }).catch((error) => {
                toast.error(error)
            })

        ApiService.get('/getAdjustHoursDescriptions')
            .then(({ data }) => {
                const formattedData = Object.entries(data.data).map(([key, value]) => ({
                    value: key,
                    label: value
                }))
                setReasonList(formattedData)
                if (formattedData.length > 0) {
                    setSelectedReason(formattedData[0].value);
                }
            }).catch((error) => {
                toast.error(error)
            })
    }, [])

    const handleDateChange = (newValue) => {
        setDateValue(dayjs(newValue).format('YYYY-MM-DD'));
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
        disableAutoFocusItem: true,
        disableListWrap: true,
    };

    const handleSubmit = () => {
        const body = {
            "Emp_Code": selectedEmp.map((a) => { return a.Emp_Code }),
            "Effective_Date": dateValue,
            "Overtime_List": selectedList,
            "Sel_Reason": selectedReason,
            "Desc_Reason": reasonDescription,
            "Hours": hours,
            "Type": selectedType,
        }
        ApiService.post('/adjustHours', body).then((data) => {
            toast.success(data?.message)
            setSelectedEmp([])
            setSelectedList('')
            setDateValue(null)
            setSelectedReason('')
            setReasonDescription('')
            setHours('')
            setSelectedType('')
            setSearchTerm('')
        }).catch((error) => {
            toast.error(error?.data?.message)
        })
    }

    return (
        <>
            <Paper className="p-4" style={{ marginTop: "1rem" }}>
                <div className='mb-4'>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5">Adjust Hours</Typography>
                        </Grid>
                    </Grid>
                </div>
                <Box component="form" noValidate autoComplete="off">
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom className='d-flex'>
                                Employees
                                {selectedEmp.length == employeesList.length ?
                                    <span className='select-all px-1 py-1' onClick={() => setSelectedEmp([])}>Unselect All</span>
                                    :
                                    <span className='select-all px-1 py-1' onClick={() => setSelectedEmp(employeesList)}>Select All</span>
                                }
                            </Typography>
                            <FormControl fullWidth>
                                {/* <Select
                                    search
                                    multiple
                                    value={employeeName}
                                    onChange={handleChange}
                                    onClose={() => setSearchTerm('')}
                                    renderValue={(selected) =>
                                        selected
                                            .map((code) => {
                                                const emp = employeesList.find((e) => e.Emp_Code === code);
                                                return emp ? (emp.EA_Rank ? `${emp.EA_Rank} ${emp.fullName}` : emp.fullName) : '';
                                            })
                                            .filter(Boolean)
                                            .join(', ')
                                    }
                                    MenuProps={MenuProps}
                                >
                                    {filteredEmployees.map(emp => (
                                        <MenuItem value={emp.Emp_Code}>
                                            <Checkbox checked={employeeName.includes(emp.Emp_Code)} />
                                            <ListItemText primary={emp.EA_Rank ? `${emp.EA_Rank} ${emp.fullName}` : emp.fullName} />
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                <div className='adjust-hrs'>
                                    <Multiselect
                                        displayValue="label"
                                        options={employeesList}
                                        showCheckbox
                                        showArrow
                                        customCloseIcon={<img src="/images/cross.png" alt="close" />}
                                        placeholder="Members"
                                        selectedValues={selectedEmp}
                                        onSelect={(e) => setSelectedEmp(e)}
                                        onRemove={(e) => setSelectedEmp(e)}
                                        customInputRenderer={(inputProps) => (
                                            <TextField
                                                {...inputProps}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: "48px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom>Effective Date</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs} className="p-0">
                                <DemoContainer components={['DatePicker', 'DatePicker']} sx={{ paddingTop: 0 }}>
                                    <DatePicker
                                        value={dayjs(dateValue)}
                                        onChange={handleDateChange}
                                        sx={{ width: '100%' }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    width: "100%",
                                                    '& .MuiOutlinedInput-root': {
                                                        height: "56px",
                                                        width: '100%',
                                                    },
                                                }
                                            }
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom>List</Typography>
                            <TextField
                                select
                                fullWidth
                                value={selectedList}
                                onChange={e => setSelectedList(e.target.value)}
                            >
                                <MenuItem value="" disabled>
                                    Select a List
                                </MenuItem>
                                {list.map(type => (
                                    <MenuItem value={type.value}>
                                        {type.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom>Reason</Typography>
                            <TextField
                                select
                                fullWidth
                                value={selectedReason}
                                onChange={e => setSelectedReason(e.target.value)}
                                MenuProps={MenuProps}
                            >
                                <MenuItem value="" disabled>
                                    Select a Reason
                                </MenuItem>
                                {reasonList.map((type) => (
                                    <MenuItem key={type.value} value={type.value}>
                                        {type.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <Typography variant="subtitle1" gutterBottom className='mt-3'>Reason Description</Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter description"
                                value={reasonDescription}
                                onChange={(e) => setReasonDescription(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom>Hours</Typography>
                            <TextField
                                type="number"
                                fullWidth
                                placeholder="Enter hours"
                                value={hours}
                                onChange={(e) => setHours(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="subtitle1" gutterBottom>Type</Typography>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Radio
                                            checked={selectedType === 'adjust'}
                                            onChange={() => setSelectedType('adjust')}
                                        />
                                    }
                                    label="Adjust"
                                />
                                <FormControlLabel
                                    control={
                                        <Radio
                                            checked={selectedType === 'reset'}
                                            onChange={() => setSelectedType('reset')}
                                        />
                                    }
                                    label="Reset"
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>
                    <ButtonTheme disabled={!(selectedEmp.length > 0 && selectedList && selectedReason && dateValue && hours && selectedType)} onClick={handleSubmit} variant="filled" color='primary' className='px-5 mt-4'>
                        Update
                    </ButtonTheme>
                </Box >
            </Paper >
        </>
    )
}

export default AdjustHours